export default class alarmCenter {
    constructor(){

    }
    getHisFileList(){
        
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvLoggingServer/index.js